<template>
  <canvas class="chartjs" :width="width" :height="height"></canvas>
</template>

<script>
  const types = ['line', 'bar', 'polarArea', 'pie', 'doughnut', 'bubble'];

  export default {
    props: {
      width: Number,
      height: Number,
      type: {
        type: String,
        required: true,
        validator: (val) => types.includes(val),
      },
      data: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      plugins: {
        type: Array,
        default: () => ([]),
      },
    },

    mounted() {
      /* const dataFromChart = this.data; */
      import('chart.js').then((Chart) => {
        Chart.pluginService.register({
          afterDatasetsDraw: (chartInstance) => {
            if (chartInstance.config.options.showBubbleLabels) {
              // To only draw at the end of animation, check for easing === 1
              const ctx = chartInstance.chart.ctx;
              
              chartInstance.data.datasets.forEach((dataset, i) => {
                
                const meta = chartInstance.getDatasetMeta(i);
                if (!meta.hidden) {
                  meta.data.forEach((element) => {
                    // Draw the text in color, with the specified font
                    ctx.fillStyle = 'rgba(67, 72, 76, 1)';
                    const fontSize = 10;
                    const fontStyle = 'normal';
                    const fontFamily = 'Helvetica Neue';
                    ctx.font = Chart.helpers.fontString(
                      fontSize,
                      fontStyle,
                      fontFamily
                    );
                    // <---- ADJUST TO DESIRED TEXT --->
                    let label = 'unknown';
                    if (dataset.label !== 'Class Average') {
                      label = dataset.label.split(' ')[0];
                    } else {
                      label = 'Class Average';
                    }
                    // Make sure alignment settings are correct
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    const position = element.tooltipPosition();
                    ctx.fillText(label, position.x, position.y);
                  });
                }
              });
            }
          },
        });
        this.chart = new Chart(this.$el, {
          type: this.type,
          data: this.data,
          options: this.options,
        });
      });
    },
    data() {
      return {
        chart: null,
      };
    },

    methods: {
      resetChart() {
        this.$nextTick(() => {
          import(
            /* webpackChunkName: "chart.js" */
            /* webpackMode: "lazy" */
            'chart.js'
          )
            .then((Chart) => {
              this.chart.destroy();
              // It ensures that new chart is properly set
              setTimeout(() => {
                this.chart = new Chart(this.$el, {
                  type: this.type,
                  data: this.data,
                  options: this.options,
                });
              });
            })
            .catch(console.error);
        });
      },
    },

    watch: {
      type() {
        this.resetChart();
      },
      data() {
        this.resetChart();
      },
      options() {
        this.resetChart();
      },
    },
  };
</script>

<style lang="scss">
  canvas.chartjs {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// chartJS.vue?a4563016